import React from 'react';

import { PreferencesPrograms } from '../components/Preferences/PreferencesPrograms';
import { useDocumentTitle } from '../hooks/useDocumentTitle';

export type ProgramsPreferencesPageProps = {
  name?: string;
};

export const ProgramsPreferencesPage = ({
  name = 'PROGRAMS_PREFERENCES_PAGE',
}: ProgramsPreferencesPageProps) => {
  useDocumentTitle('Preferences');
  return (
    <div data-test={name}>
      <PreferencesPrograms />
    </div>
  );
};
